var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H42C47.5228 0 52 4.47715 52 10V43C52 48.5228 47.5228 53 42 53H10C4.47715 53 0 48.5228 0 43V10Z",
    fill: "url(#paint0_linear_44_1531)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0148C0 4.49193 4.47715 0.0147705 10 0.0147705H42C47.5228 0.0147705 52 4.49192 52 10.0148V43.0042C52 48.527 47.5228 53.0042 42 53.0042H10C4.47715 53.0042 0 48.527 0 43.0042V10.0148Z",
    fill: "url(#paint1_linear_44_1531)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7125 28.595C27.9758 28.595 29.8105 26.7079 29.8105 24.38C29.8105 22.0522 27.9758 20.165 25.7125 20.165C23.4493 20.165 21.6146 22.0522 21.6146 24.38C21.6146 26.7079 23.4493 28.595 25.7125 28.595Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2813 38.3001C33.2813 34.8051 29.898 31.9551 25.7125 31.9551C21.5271 31.9551 18.1438 34.7901 18.1438 38.3001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.625 26.75C39.625 34.625 33.427 41 25.7708 41C18.1145 41 11.9166 34.625 11.9166 26.75C11.9166 18.875 18.1145 12.5 25.7708 12.5C27.6812 12.5 29.5041 12.89 31.1666 13.61C30.977 14.21 30.875 14.84 30.875 15.5C30.875 16.625 31.1812 17.69 31.7208 18.59C32.0125 19.1 32.3916 19.565 32.8291 19.955C33.85 20.915 35.2062 21.5 36.7083 21.5C37.35 21.5 37.9625 21.395 38.5312 21.185C39.2312 22.895 39.625 24.785 39.625 26.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5417 15.5C42.5417 15.98 42.4833 16.445 42.3667 16.895C42.2354 17.495 42.0021 18.08 41.6958 18.59C40.9958 19.805 39.8729 20.75 38.5312 21.185C37.9625 21.395 37.35 21.5 36.7083 21.5C35.2062 21.5 33.85 20.915 32.8292 19.955C32.3917 19.565 32.0125 19.1 31.7208 18.59C31.1813 17.69 30.875 16.625 30.875 15.5C30.875 14.84 30.9771 14.21 31.1667 13.61C31.4438 12.74 31.9104 11.96 32.5229 11.315C33.5875 10.19 35.075 9.5 36.7083 9.5C38.4292 9.5 39.9896 10.265 41.0396 11.495C41.9729 12.56 42.5417 13.97 42.5417 15.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8812 15.47H34.5354",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7084 13.28V17.765",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1531",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22DED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_1531",
    x1: 26,
    y1: 0.0147705,
    x2: 26,
    y2: 53.0042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CA4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmp);
export default __webpack_public_path__ + "static/media/iconEmp.a56565978d6f89d60a61e156f0ba6852.svg";
export { ForwardRef as ReactComponent };